import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EtablissementData } from '../../../../../../../shared/utils/data/etablissments-data';
import { FormBuilder, Validators } from '@angular/forms';
import { EstablishmentService } from '../../../../../../../services/establishment.service';
import { AddressService } from '../../../../../../../services/address.service';
import { FlagService } from '../../../../../../../shared/services/flag.service';
import { AuthService } from '../../../../../../../services/auth.service';
import { FlagType } from '../../../../../../../shared/utils/enums';

@Component({
  selector: 'app-add-site',
  templateUrl: './add-site.component.html',
  styleUrl: './add-site.component.scss',
})
export class AddSiteComponent implements OnInit {
  addressImages: any[] = [];
  form = this.fb.group({
    name: ['', Validators.required],
    adress: ['', Validators.required],
    address: ['', Validators.required],
    pays: ['', Validators.required],
    codePostale: ['', Validators.required],
    regionCode: ['', Validators.required],
    regionName: ['', Validators.required],
    ville: ['', Validators.required],
    departmentName: ['', Validators.required],
    isvisible: true,
    issocial: false,
    cedex: ['', [Validators.minLength(2), Validators.maxLength(2)]],
    firstPhoto: [<string | null>null],
    secondPhoto: [<string | null>null],
    id: [<string | null>null],
    lat: [<number | null>null],
    lon: [<number | null>null],
  });
  addressList: any[] = [];
  loading = false;
  constructor(
    public dialogRef: MatDialogRef<AddSiteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private establishmentService: EstablishmentService,
    private flag: FlagService,
    private auth: AuthService,
    private addressService: AddressService
  ) {}
  ngOnInit(): void {
    if (this.data.site) {
      this.data.site.isVisible = this.data.site.isvisible;
      this.data.site.address = this.data.site.adress;
      if (this.data.site.firstPhoto == '' || !this.data.site.firstPhoto) {
        this.data.site.firstPhoto = null;
      }

      this.addressImages.push(this.data.site.firstPhoto);

      if (this.data.site.secondPhoto == '' || !this.data.site.secondPhoto) {
        this.data.site.secondPhoto = null;
      }

      this.addressImages.push(this.data.site.secondPhoto);

      this.form.patchValue(this.data.site);

    }
  }

  autoCompleteOnChange(event: any) {
    this.getAddresses(event?.value);
  }
  getAddresses(wordKey: string) {
    this.form.get('adress')?.markAsTouched();
    this.form.get('regionCode')?.markAsTouched();
    if (wordKey) {
      this.establishmentService
        .getAddress(wordKey, 'france')
        .subscribe((value) => {
          this.addressList = value.filter(
            (value: any) => value.address.country_code === 'fr'
          );
        });
    } else {
      this.form.get('adress')?.patchValue('');
      this.form.get('regionCode')?.patchValue('');
      this.form.get('regionName')?.patchValue('');
      this.form.markAsTouched();
    }
  }
getAdresseFormated(option: any) {
    const address = option?.address || {};
    const house_number = address?.house_number || '';
    const road = address?.road || ''; 
    const postcode = address?.postcode || ''; 
    const city = address?.city || address?.town || address?.village || ''; 
    const country = address?.country || ''; 
    const fullRoad = house_number + ' ' + road;
      const addressComponents = [
        fullRoad,
        `${postcode} ${city}`,
        country
    ];
    const filteredComponents = addressComponents.filter(component => component.trim() !== '');
    return filteredComponents.join(', ')
}
  addressSelected(item: any): void {
    this.form.get('lat')?.patchValue(+item.lat);
    this.form.get('lon')?.patchValue(+item.lon);
    this.form.get('adress')?.patchValue(this.getAdresseFormated(item));
    this.form.get('codePostale')?.patchValue(item.address.postcode);
    this.form.get('pays')?.patchValue(item?.address.country);
    this.form.get('ville')?.patchValue(item?.address.city||item?.address?.town||item?.address?.village);
    this.form.get('departmentName')?.patchValue(item?.address.county||item?.address.city||item?.address?.town||item?.address?.village);
    this.establishmentService
      .getRegionByPostalCode(item.address.postcode)
      .subscribe({
        next: (res) => {
          this.form.get('regionCode')?.patchValue(res[0].codeRegion);

          this.establishmentService
            .getRegionByCode(res[0].codeRegion)
            .subscribe({
              next: (res) => {
                this.form.get('regionName')?.patchValue(res.nom);
              },
            });
        },
      });
  }

  getImage(images: string[]) {
    this.form.get('firstPhoto')?.patchValue(null);
    this.form.get('secondPhoto')?.patchValue(null);

    if (images[0]) {
      this.addressImages[0] = images[0];
      this.form.get('firstPhoto')?.patchValue(images[0]);
    }
    if (images[1]) {
      this.addressImages[1] = images[1];
      this.form.get('secondPhoto')?.patchValue(images[1]);
    }
  }

  addSite() {
    this.loading = true;
    const body = this.form.value;
    delete body.address;

    this.addressService.addAddress(body, this.auth.id!).subscribe({
      next: (value) => {
        this.loading = false;
        this.dialogRef.close(true);
        this.flag.displayFlag(
          `Site ${this.data.isModify ? 'modifié' : 'ajouté'} avec succès !`,
          FlagType.success
        );
      },
      error: (err) => {},
    });
  }

  protected readonly EtablissementData = EtablissementData;
}
